import React from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';

import './loading-overlay.scss';

const DURATION = 1400.00;
const OFFSET = 187.00;
const getNow = () => window.performance ? window.performance.now() : new Date().valueOf();

const transitionStyles: any = {
    entering: { opacity: 1 },
    entered: { opacity: 1 },
    exiting: { opacity: 0 },
    exited: { opacity: 0, display: 'none' },
};
const beginAnimation = ( element: any ) => {
    if ( element && typeof window.requestAnimationFrame === 'function' ) {
        const svg = element.childNodes[ 0 ];
        const group = svg.childNodes[ 0 ];
        const circle = group.childNodes[ 0 ];
        const startTime = getNow();
        const animate = () => {
            const percent = ( ( ( getNow() - startTime ) / DURATION ) % 1 ) ;
            const groupRoteate = percent * 270;
            group.setAttribute( 'transform', 'rotate(' + groupRoteate.toString() + ', 33, 33)' );
            const strokeDashoffset = ( Math.abs( percent - .5 ) / .5 ) * ( OFFSET - ( OFFSET / 4 ) ) + ( OFFSET / 4 );
            circle.style.strokeDashoffset = strokeDashoffset;
            const strokeOpacity = percent;
            circle.style.opacity = strokeOpacity;
            const strokeRotate = percent * 450;
            circle.setAttribute( 'transform', 'rotate(' + strokeRotate.toString() + ', 33, 33)' );
            window.requestAnimationFrame( animate );
        };
        animate();
    }
};
const DefaultLoader = () => (
    <div className="activity-indicator" ref={beginAnimation} >
        <svg className="spinner client-svg" viewBox="0 0 66 66">
            <g><circle className="path" cx="33" cy="33" r="30"/></g>
        </svg>

    </div>
);

interface Props {
    children?: any;
    isLoading: boolean;
}
const LoadingOverlay = ( { isLoading = true, children }: Props ) => (
    <Transition timeout={300} in={isLoading}>
        { (state: any) => (
            <div className="loading-overlay" style={{ ...transitionStyles[state] }} >
                <div className="loading-indicator">
                    <div className="loader">
                        {children || <DefaultLoader />}
                    </div>
                </div>
            </div>
        ) }
    </Transition>
);

LoadingOverlay.propTypes = {
    isLoading: PropTypes.bool,
    children: PropTypes.node,
};

export default LoadingOverlay;
